export var InputType;
(function (InputType) {
    InputType["SELECT"] = "select";
    InputType["RANGE"] = "range";
    InputType["TERC_PICKER"] = "tercpicker";
    InputType["SIMC_PICKER"] = "simcpicker";
})(InputType || (InputType = {}));
//# sourceMappingURL=inputType.enum.js.map